import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    padding: (props) => props.isTinyMce ? 0 : theme.spacing(2, 4)
  }
}))
